import { NETWORK } from "../utils/constants";
const ethereum = typeof window !== "undefined" ? window.ethereum : "";

// check if metamask extension is installed on the browser
export const isMetaMaskInstalled = () => {
  if (ethereum) {
    return true;
  }

  return false;
};

// connect to metakmask wallet
export const connectWallet = async () => {
  const accounts = await ethereum
    .request({ method: "eth_requestAccounts" })
    .catch((err) => {
      if (err.code === 4001) {
        // EIP-1193 userRejectedRequest error
        // If this happens, the user rejected the connection request.
        console.log("Please connect to MetaMask.");
      } else {
        console.error(err);
      }
    });
  return accounts;
};

// connect to metakmask wallet
export const isAccountConnected = async () => {
  if (typeof ethereum !== "undefined") {
    const accounts = await ethereum.request({ method: "eth_accounts" });
    console.log("accounts", accounts);
    return true;
  }
};

// metakmask wallet
export const AccountsMetamask = async () => {
  if (typeof ethereum !== "undefined") {
    const accounts = await ethereum.request({ method: "eth_accounts" });

    return accounts[0];
  }
};

// disconnect metamask wallet
export const disconnectWallet = async () => {
  localStorage.removeItem("isWalletConnected");
  console.log("disconnect wallet");
  await ethereum.request({
    method: "wallet_revokePermissions",
    params: [
      {
        eth_accounts: {},
      },
    ],
  });
};

// check metamask on disconnect
if (isMetaMaskInstalled()) {
  ethereum.on("accountsChanged", () => {
    console.log("accountsChanged");
    // window.location.reload();
  });
}

// check metamask on connected
export const onMetamaskconnect = async () => {
  const chainId = await getChainId();
  ethereum.on("connect", () => {
    console.log(chainId);
  });
};

// on chain change
export const onChainChange = (
  network,
  setNetwork,
  setNetworkModalVisibility
) => {
  if (typeof ethereum !== "undefined") {
    ethereum.on("chainChanged", (_chainId) => {
      setNetwork(parseInt(_chainId));
      setNetworkModalVisibility(false);
      if (parseInt(_chainId) != NETWORK) {
        setNetworkModalVisibility(true);
      }
      return parseInt(_chainId);
    });
  }
};

export const getChainId = async () => {
  const chainId = await ethereum.request({ method: "eth_chainId" });

  return parseInt(chainId);
};

export const isWalletConnected = () => {
  if (localStorage.getItem("isWalletConnected") === "true") {
    return true;
  }

  return false;
};

export const connectWalletLocaly = () => {
  localStorage.setItem("isWalletConnected", true);
};
